<div class="consent-container">

    <ng-container *ngIf="calendarReference?.CalendarIsSetup">
        <button (click)="showCalendarSettings()" class="btn btn-success mt-2" *ngIf="!loading">Update calendar settings</button>
    </ng-container>

    <div *ngIf="calendarReference?.CalendarIsSetup && calendarReference?.CalendarHasErrors && showCalendarError && (allCalendars?.length==0)">
        <div class="dw-red">
            We were unable to access your calendar at {{calendarLastErrorDateTime}}. If you continue to have issues, reconnect your Google Calendar below.
        </div>

        <dw-button-bar *ngIf="!loading">
            <button (click)="getOAuthConsent()" class="btn btn-google">
                <img src="/assets/google/img/google-calendar-icon.png" class="google-icon" />
                Reconnect Google Calendar
            </button>

            <button (click)="removeAccess()" class="btn btn-warning">Remove Access</button>
        </dw-button-bar>
    </div>
    <ng-container *ngIf="!calendarReference?.CalendarIsSetup">
        <!-- Authorize Pilexos to access your Google Calendar and book checkride events on your behalf. -->
        <div dwRow *ngIf="false">
            <div dwCol="6">
                <label class="label">Manual Code <i class="fa fa-info-circle"
                        title="Checkride events will be created on this calendar"></i></label>

                <a [href]="authUrl" target="_blank">Google Auth url</a>

                <input type="text" [(ngModel)]="manualCode" placeholder="Manual Code" class="form-control" />
            </div>
        </div>

        <br><br>
        <button (click)="getOAuthConsent()" class="btn btn-google" *ngIf="!loading">
            <img src="/assets/google/img/google-calendar-icon.png" class="google-icon" />

            Connect Google Calendar
        </button>

        <br><br>

        <p><a href="https://pilexos.com/privacy-policy" target="_blank" title="See our full privacy policy" class="dw-link">PiExOS Privacy Policy</a></p>

        <div *ngIf="false">
            <a (click)="togglePrivacy()" [hidden]="showPrivacy" class="dw-link mt-4" >How we use your data</a>

            <div [hidden]="!showPrivacy">
                <p>PiExOS uses google calendar access to determine your availability and to book checkride events on your behalf.  We do not share your information with any third parties.</p>

                
                <p><a href="https://pilexos.com/privacy-policy" target="_blank" title="">PiExOS Privacy Policy</a></p>

                
                <p>PiExOS' use and transfer of information received from Google APIs to any other app will adhere to <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank">Google API Services User Data Policy</a>, including the Limited Use requirements.</p>
            </div>
        </div>


    </ng-container>

    <div class="mt-2 mr-2">
        <dw-loading [show]="loading" [text]="loadingMessage"></dw-loading>

        <dw-message [(message)]="message"></dw-message>
    </div>
</div>
